<template>
  <div>
    <h5 class="account_title">
      {{ $t("Bao.account_info") }}
    </h5>
    <ul class="personal_list list-unstyled mb-20">
      <li>
        <h5 class="mb-0">
          {{ $t("Bao.nickname") }}
        </h5>
        <h5 v-if="$store.getters.user.nickname" class="mb-0">
          {{ $store.getters.user.nickname }}
        </h5>
        <h5 v-else class="not_set mb-0">
          {{ $t("Bao.not_setting") }}
        </h5>
      </li>
      <li>
        <h5 class="mb-0">
          {{ $t("Bao.actual_name") }}
        </h5>
        <h5 v-if="$store.getters.user.name" class="mb-0">
          {{ $store.getters.user.name }}
        </h5>
        <h5 v-else class="not_set mb-0">
          {{ $t("Bao.not_setting") }}
        </h5>
      </li>
      <li>
        <h5 class="mb-0">
          {{ $t("Bao.phone") }}
        </h5>
        <h5 v-if="$store.getters.user.phone" class="mb-0">
          {{ $store.getters.user.phone }}
        </h5>
        <h5 v-else class="not_set mb-0">
          {{ $t("Bao.not_setting") }}
        </h5>
      </li>
      <li>
        <h5 class="mb-0">
          {{ $t("Bao.email") }}
        </h5>
        <h5 v-if="$store.getters.user.email" class="mb-0">
          {{ $store.getters.user.email }}
        </h5>
        <h5 v-else class="not_set mb-0">
          {{ $t("Bao.not_setting") }}
        </h5>
      </li>
      <li>
        <h5 class="mb-0">
          {{ $t("Bao.login_password") }}
        </h5>
        <h5 v-if="$store.getters.user.password" class="mb-0">
          {{ $t("Bao.login_password_has_set") }}
        </h5>
        <h5 v-else class="not_set mb-0">
          {{ $t("Bao.not_setting") }}
        </h5>
      </li>
      <li>
        <h5 class="mb-0">
          {{ $t("Bao.withdrawal_password") }}
        </h5>
        <h5 v-if="$store.getters.user.withdrawal_pass" class="mb-0">
          {{ $t("Bao.withdrawal_password_has_set") }}
        </h5>
        <h5 v-else class="text-red mb-0">
          {{ $t("Bao.not_setting") }}
        </h5>
      </li>
      <li>
        <h5 class="mb-0">
          {{ $t("Bao.address") }}
        </h5>
        <h5 v-if="$store.getters.user.address" class="mb-0">
          {{ $store.getters.user.address }}
        </h5>
        <h5 v-else class="not_set mb-0">
          {{ $t("Bao.not_setting") }}
        </h5>
      </li>
    </ul>
    <div class="d-flex justify-content-center">
      <button class="btn btn_set" type="button" @click="showModal()">
        <span>{{ $t("Bao.not_set_yet") }}</span>
      </button>
    </div>

    <!--modal_set-->
    <b-modal
      id="modal_set"
      ref="modal_set"
      modal-class="modal modal_tips modal_set modal_wallet fade"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      dialog-class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-md"
      header-class="modal-header justify-content-center align-items-center border-bottom-0"
      footer-class="modal-footer justify-content-center border-top-0"
      content-class="modal-content"
    >
      <template v-slot:modal-header>
        <h4 class="mb-0">
          <b>{{ $t("Bao.setting") }}{{ $t("Bao.account_info") }}</b>
        </h4>
        <button type="button" class="close rounded-circle m-0" data-dismiss="modal" aria-label="Close" @click="$bvModal.hide('modal_set')">
          <i class="icon-clear" />
        </button>
      </template>
      <div class="modal-body text-center">
        <div class="bank_area">
          <form class="account_form mb-0 d-grid" autocomplete="false">
            <div class="account_form_col d-grid align-items-start">
              <div class="account_form_list d-grid align-items-center">
                <label class="account_subtitle mb-0" for="">{{ $t("Bao.nickname") }}<small>*</small></label>
                <span class="position-relative">
                  <input v-model="updateUser.nickname" v-validate="'required'" :class="['account_form_ipt', 'w-100', { is_false: errors.has('nickname') }]" type="text" :data-vv-as="$t('Bao.nickname')" name="nickname" :placeholder="pleaseEnterTip('nickname')">
                  <small class="false_status text-left">{{ errors.first('nickname') }}</small>
                </span>
              </div>
              <div class="account_form_list d-grid align-items-center">
                <label class="account_subtitle mb-0" for="">{{ $t("Bao.username") }}<small>*</small></label>
                <span class="position-relative">
                  <input class="account_form_ipt w-100" type="text" :value="$store.getters.user.username" disabled>
                </span>
              </div>
            </div>
            <div class="account_form_col d-grid align-items-start">
              <div class="account_form_list d-grid align-items-center ">
                <label class="account_subtitle mb-0" for="">{{ $t("Bao.phone") }}<small>*</small></label>
                <span class="position-relative">
                  <input v-if="$store.getters.user.phone" class="account_form_ipt w-100" type="text" :value="$store.getters.user.phone" disabled>
                  <button v-else type="button" :class="$store.getters.brand.theme" class="btn btn_main text-white w-100" @click="goPhoneVerify()">
                    {{ $t("Bao.go_verify") }}
                  </button>
                </span>
              </div>
              <div class="account_form_list d-grid align-items-center">
                <label class="account_subtitle mb-0" for="">{{ $t("Bao.birthday") }}</label>
                <span class="position-relative">
                  <input v-if="$store.getters.user.birthday" class="account_form_ipt w-100" type="text" :value="$store.getters.user.birthday" disabled>
                  <input v-else v-model="updateUser.birthday" type="date" :data-vv-as="$t('Bao.birthday')" name="birthday" class="account_form_ipt w-100">
                  <span class="calendar-icon"><img src="@/assets/img/icon_calendar.svg" alt="" height="20"></span>
                </span>
              </div>
            </div>
            <div class="account_form_col d-grid align-items-start">
              <div class="account_form_list d-grid align-items-center">
                <label class="account_subtitle mb-0" for="">{{ $t("Bao.actual_name") }}<small>*</small></label>
                <span class="position-relative">
                  <input v-if="$store.getters.user.name" class="account_form_ipt w-100" type="text" :value="$store.getters.user.name" disabled>
                  <input v-else v-model="updateUser.name" v-validate="'required'" :class="['account_form_ipt', 'w-100', { is_false: errors.has('name') }]" type="text" :data-vv-as="$t('Bao.name')" name="name" :placeholder="pleaseEnterTip('actual_name')">
                  <small class="false_status text-left">{{ errors.first('name') }}</small>
                </span>
              </div>
              <div class="account_form_list d-grid align-items-center">
                <label class="account_subtitle mb-0" for="">{{ $t("Bao.email") }}</label>
                <span class="position-relative">
                  <input
                    v-if="$store.getters.user.email"
                    class="account_form_ipt w-100"
                    type="text"
                    :value="$store.getters.user.email"
                    disabled
                  >
                  <button v-else-if="$store.getters.permissionInfo.email_need_verify == 1" type="button" :class="$store.getters.brand.theme" class="btn btn_main text-white w-100" @click="goEmailVerify()">
                    {{ $t("Bao.go_verify") }}
                  </button>
                  <input
                    v-else
                    v-model="updateUser.email"
                    v-validate="'email'"
                    :class="['account_form_ipt', 'w-100', { is_false: errors.has('email') }]"
                    :data-vv-as="$t('Bao.email')"
                    name="email"
                    :placeholder="pleaseEnterTip('email')"
                    type="text"
                    :readonly="emailReadOnly"
                    autocomplete="new-password"
                    @focus="handleEmailType"
                    @blur="handleEmailType"
                  >
                  <small class="false_status text-left">{{ errors.first('email') }}</small>
                </span>
              </div>
            </div>
            <div class="account_form_col d-grid align-items-start">
              <div class="account_form_list d-grid align-items-center">
                <label class="account_subtitle mb-0" for="">{{ $t("Bao.modify") }}{{ $t("Bao.login_password") }}</label>
                <span class="position-relative">
                  <input
                    v-model="updateUser.newPassword"
                    v-validate="'min:6'"
                    :class="['account_form_ipt', 'w-100', { is_false: errors.has('newPassword') }]"
                    :data-vv-as="$t('Bao.newPassword')"
                    name="newPassword"
                    :placeholder="$t('Bao.please_leave_blank_if_not_set')"
                    :type="newPasswordType"
                    :readonly="newPasswordReadOnly"
                    autocomplete="new-password"
                    @focus="handleNewPasswordType"
                    @blur="handleNewPasswordType"
                  >
                  <small class="false_status text-left">{{ errors.first('newPassword') }}</small>
                </span>
              </div>
              <div class="account_form_list d-grid align-items-center">
                <label class="account_subtitle mb-0" for="">{{ $t("Bao.confirm") }}{{ $t("Bao.login_password") }}</label>
                <span class="position-relative">
                  <input
                    v-model="updateUser.confirmPassword"
                    v-validate="'min:6'"
                    :class="['account_form_ipt', 'w-100', { is_false: errors.has('confirmPassword') }]"
                    :data-vv-as="$t('Bao.newPassword')"
                    name="confirmPassword"
                    :placeholder="$t('Bao.please_leave_blank_if_not_set')"
                    :type="confirmPasswordType"
                    :readonly="confirmPasswordReadOnly"
                    autocomplete="new-password"
                    @focus="handleConfirmPasswordType"
                    @blur="handleConfirmPasswordType"
                  >
                  <small class="false_status text-left">{{ errors.first('confirmPassword') }}</small>
                </span>
              </div>
            </div>
            <div class="account_form_col d-grid align-items-start">
              <div class="account_form_list full d-grid align-items-center">
                <label class="account_subtitle mb-0" for="">{{ $t("Bao.withdrawal_password") }}<small>*</small></label>
                <span class="position-relative">
                  <input v-if="$store.getters.user.withdrawal_pass == 'has set'" v-model="updateUser.withdrawal_pass" v-validate="'min:4|max:4|integer'" :data-vv-as="$t('Bao.withdrawal_pass')" :class="['account_form_ipt', 'w-100', { is_false: errors.has('withdrawal_pass') }]" type="password" name="withdrawal_pass" :placeholder="$t('Bao.has_set') + ' ' + $t('Bao.please_leave_blank_if_not_set')" maxlength="4">
                  <input v-else v-model="updateUser.withdrawal_pass" v-validate="'required|min:4|max:4|integer'" :data-vv-as="$t('Bao.withdrawal_pass')" :class="['account_form_ipt', 'w-100', { is_false: errors.has('withdrawal_pass') }]" type="password" name="withdrawal_pass" :placeholder="pleaseEnterTip('withdrawal_pass')" maxlength="4">
                  <small class="false_status text-left">{{ errors.first('withdrawal_pass') }}</small>
                </span>
              </div>
            </div>
            <div class="account_form_col d-grid align-items-start">
              <div class="account_form_list full d-grid align-items-center">
                <label class="account_subtitle mb-0" for="">{{ $t("Bao.address") }}</label>
                <span class="position-relative">
                  <input v-model="updateUser.address" :class="['account_form_ipt', 'w-100', { is_false: errors.has('address') }]" type="text" name="address" :placeholder="pleaseEnterTip('address')">
                  <small class="false_status text-left">{{ errors.first('address') }}</small>
                </span>
              </div>
            </div>
          </form>
        </div>
      </div>
      <template v-slot:modal-footer>
        <div class="wallet_transfer_btn modal_btns d-flex justify-content-center w-100">
          <button type="button" class="btn btn_transfer text-white" @click="save">
            {{ $t("Bao.save_setting") }}
          </button>
          <button type="button" class="btn btn_immediately" data-dismiss="modal" @click="$bvModal.hide('modal_set')">
            {{ $t("Bao.cancel") }}
          </button>
        </div>
      </template>
    </b-modal>

    <b-modal
      id="modal_phone_verify"
      ref="modal_phone_verify"
      modal-class="modal_bet_detail modal_phone_verify"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      dialog-class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-md"
      header-class="modal-header justify-content-center align-items-center border-bottom-0"
      footer-class="modal-footer justify-content-center border-top-0"
      content-class="modal-content"
    >
      <template v-slot:modal-header>
        <h4 class="mb-0">
          <b>{{ $t("Bao.verify") }}{{ $t("Bao.phone") }}</b>
        </h4>
        <button type="button" class="close rounded-circle m-0" data-dismiss="modal" aria-label="Close" @click="$bvModal.hide('modal_phone_verify')">
          <i class="icon-clear" />
        </button>
      </template>
      <div class="modal-body">
        <form class="mb-0" action="" autocomplete="off">
          <div class="form-group">
            <label class="form_lab">{{ $t("Bao.self_info") }}</label>
            <vue-tel-input
              v-model="verifyPhone"
              v-validate="'required'"
              class="form_ipt_tel"
              :input-classes="'form-control'"
              :placeholder="$t('Bao.please_input')+$t('Bao.phone')"
              name="phone"
              :data-vv-as="$t('Bao.phone')"
              :only-countries="countryList"
              :default-country="defaultCountry"
              mode="international"
              :required="true"
            />
          </div>
          <div class="form-group">
            <label class="form_lab">{{ $t('Bao.validateCode') }}</label>
            <div class="d-flex justify-content-between">
              <input
                v-model="verifyPhoneCode"
                v-validate="'required'"
                class="form-control mr-10"
                :placeholder="$t('Bao.please_input')+$t('Bao.validateCode')"
                type="text"
                name="validateCode"
                :data-vv-as="$t('Bao.validateCode')"
              >
              <button
                type="button"
                :class="$store.getters.brand.theme"
                class="btn btn_main text-white px-2"
                @click="getCode"
              >
                <i v-show="gettingVerify" class="fa fa-spinner fa-pulse fa-fw" />
                {{ $t('Bao.get_verification_code') }}
              </button>
            </div>
            <small v-if="errors.has('validateCode')" class="help-block">{{ errors.first('validateCode') }}</small>
          </div>
        </form>
      </div>
      <template v-slot:modal-footer>
        <button type="button" :class="$store.getters.brand.theme" class="btn btn_main text-white w-120" @click="verify()">
          <span>{{ $t("Bao.verify") }}</span>
        </button>
      </template>
    </b-modal>

    <b-modal
      id="modal_email_verify"
      ref="modal_email_verify"
      modal-class="modal_bet_detail"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      dialog-class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-md"
      header-class="modal-header justify-content-center align-items-center border-bottom-0"
      footer-class="modal-footer justify-content-center border-top-0"
      content-class="modal-content"
    >
      <template v-slot:modal-header>
        <h4 class="mb-0">
          <b>{{ $t("Bao.verify") }}{{ $t("Bao.email") }}</b>
        </h4>
        <button type="button" class="close rounded-circle m-0" data-dismiss="modal" aria-label="Close" @click="$bvModal.hide('modal_email_verify')">
          <i class="icon-clear" />
        </button>
      </template>
      <div class="modal-body">
        <form class="mb-0" action="" autocomplete="off">
          <div class="form-group">
            <label class="form_lab">{{ $t("Bao.email") }}</label>
            <input
              v-model="verifyEmail"
              v-validate="'email'"
              :class="['form-control', 'w-100', { is_true: !errors.has('email') }, { is_false: errors.has('email') }]"
              :data-vv-as="$t('Bao.email')"
              name="email"
              :placeholder="pleaseEnterTip('email')"
              type="text"
              autocomplete="new-password"
              @focus="handleEmailType"
              @blur="handleEmailType"
            >
          </div>
          <div class="form-group">
            <label class="form_lab">{{ $t('Bao.validateCode') }}</label>
            <div class="d-flex justify-content-between">
              <input
                v-model="verifyEmailCode"
                v-validate="'required'"
                class="form-control mr-10"
                :placeholder="$t('Bao.please_input')+$t('Bao.validateCode')"
                type="text"
                name="validateCode"
                :data-vv-as="$t('Bao.validateCode')"
              >
              <button
                type="button"
                :class="$store.getters.brand.theme"
                class="btn btn_main text-white"
                @click="getMailCode"
              >
                <i v-show="gettingVerify" class="fa fa-spinner fa-pulse fa-fw" />
                {{ $t('Bao.get_verification_code') }}
              </button>
            </div>
            <small v-if="errors.has('validateCode')" class="help-block">{{ errors.first('validateCode') }}</small>
          </div>
        </form>
      </div>
      <template v-slot:modal-footer>
        <button type="button" :class="$store.getters.brand.theme" class="btn btn_main text-white w-120" @click="verifyMailCode()">
          <span>{{ $t("Bao.verify") }}</span>
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { update, getPhoneCode, verifyPhoneCode, getEmailCode, verifyEmailCode } from '@/api/user'
import { setErrorMessage, showNotice } from '@/utils/tool'
import { VueTelInput } from 'vue-tel-input'

export default {
  components: {
    VueTelInput
  },
  data() {
    return {
      updateUser: {},
      verifyPhone: '',
      verifyPhoneCode: '',
      gettingVerify: false,
      verifyEmail: '',
      verifyEmailCode: '',
      inputType: 'text',
      countryList: [],
      defaultCountry: '',
      newPasswordType: 'text',
      newPasswordReadOnly: true,
      confirmPasswordType: 'text',
      confirmPasswordReadOnly: true,
      emailReadOnly: true
    }
  },
  created() {
    this.initUpdateUser()
    console.log(this.updateUser)
    this.countryList = this.$store.getters.supportPhoneCode
    this.defaultCountry = this.countryList[0]
  },
  methods: {
    initUpdateUser() {
      this.updateUser = {
        nickname: this.$store.getters.user.nickname,
        email: this.$store.getters.user.email,
        newPassword: '',
        confirmPassword: '',
        name: this.$store.getters.user.name,
        withdrawal_pass: '',
        address: this.$store.getters.user.address,
        birthday: this.$store.getters.user.birthday
      }
    },
    showModal() {
      // this.betDetail = item
      this.$bvModal.show('modal_set')
    },
    hideModal() {
      this.$bvModal.hide('modal_set')
    },
    goPhoneVerify() {
      this.$bvModal.hide('modal_set')
      this.$bvModal.show('modal_phone_verify')
    },
    getCode() {
      this.gettingVerify = true
      getPhoneCode({ phone: this.verifyPhone }).then(response => {
        showNotice(response.data.msg)
        this.gettingVerify = false
      }).catch((error) => {
        showNotice(error.response.data.msg)
        this.gettingVerify = false
      })
    },
    verify() {
      verifyPhoneCode({ phone: this.verifyPhone, validateCode: this.verifyPhoneCode }).then(response => {
        this.$bvModal.hide('modal_phone_verify')
        showNotice(this.$t('Bao.update_success'))

        this.$store.commit('SET_MEMBER_INFO', response.data.data.member_info)
        this.initUpdateUser()
      }).catch((error) => {
        showNotice(error.response.data.msg)
      })
    },
    goEmailVerify() {
      this.$bvModal.hide('modal_set')
      this.$bvModal.show('modal_email_verify')
    },
    getMailCode() {
      this.gettingVerify = true
      getEmailCode({ email: this.verifyEmail }).then(response => {
        showNotice(response.data.msg)
        this.gettingVerify = false
      }).catch((error) => {
        showNotice(error.response.data.msg)
        this.gettingVerify = false
      })
    },
    verifyMailCode() {
      verifyEmailCode({ email: this.verifyEmail, validateCode: this.verifyEmailCode }).then(response => {
        this.$bvModal.hide('modal_phone_verify')
        showNotice(this.$t('Bao.update_success'))

        this.$store.commit('SET_MEMBER_INFO', response.data.data.member_info)
        this.initUpdateUser()
      }).catch((error) => {
        showNotice(error.response.data.msg)
      })
    },
    save() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          // this.updateUser.birthday = moment(this.dateRange.startDate).format('YYYY/MM/DD')
          update(this.updateUser).then(response => {
            this.$bvModal.hide('modal_set')
            showNotice(this.$t('Bao.update_success'))
            this.$store.commit('SET_MEMBER_INFO', response.data.data.member_info)
            this.initUpdateUser()
          }).catch((error) => {
            setErrorMessage(error.response, this.errors)
          })
        }
      })
    },
    inputClasses(checkField) {
      if (checkField === undefined) return ['form-control']
      return ['form-control', { 'is-invalid': this.errors.has(checkField) }]
    },
    pleaseEnterTip(filed) {
      return this.$t('Bao.please_input') + this.$t('Bao.' + filed)
    },
    changeType() {
      this.inputType = 'password'
    },
    handleNewPasswordType(event) {
      const { srcElement, type } = event
      const { name, value } = srcElement
      console.log(name)
      if (type === 'blur' && !value) {
        this.newPasswordType = 'text'
        this.newPasswordReadOnly = true
      } else {
        this.newPasswordType = 'password'
        this.newPasswordReadOnly = false
      }
    },
    handleConfirmPasswordType(event) {
      const { srcElement, type } = event
      const { name, value } = srcElement
      console.log(name)
      if (type === 'blur' && !value) {
        this.confirmPasswordType = 'text'
        this.confirmPasswordReadOnly = true
      } else {
        this.confirmPasswordType = 'password'
        this.confirmPasswordReadOnly = false
      }
    },
    handleEmailType(event) {
      const { srcElement, type } = event
      const { name, value } = srcElement
      console.log(name)
      if (type === 'blur' && !value) {
        this.emailReadOnly = true
      } else {
        this.emailReadOnly = false
      }
    }
  }
}
</script>

<style>
.self_form_ipt {
  border: 2px solid transparent;
  border-radius: 10px;
  font-size: 14px;
  line-height: 20px;
  padding: 8px 10px;
}

.modal_phone_verify .form_lab {
  font-size: 14px;
  color: #979797;
}
</style>
